/**
 * The kinds of analytics events.
 */
export const AnalyticsEventTypes = Object.freeze({
  ContentViewed: 'content_viewed',
  DropFilterSelected: 'drop_filter_selected',
  DropNotificationClicked: 'drop_notification_clicked',
  DropNotificationDisplayed: 'drop_notification_displayed',
  DropNotificationReceived: 'drop_notification_received',
  DropOverlayOpened: 'drop_overlay_opened',
  DropShared: 'drop_shared',
  DropViewed: 'drop_viewed',
  Heartbeat: 'heartbeat',
  HomeLeagueFilterSet: 'home_league_filter_set',
  LiveMatchViewed: 'live_match_viewed',
  LoginStarted: 'login_started',
  Logout: 'logout',
  NewsContentFilterAdded: 'news_content_filter_added',
  NewsContentFilterRemoved: 'news_content_filter_removed',
  PageView: 'page_view',
  PartnerBanner: 'partner_banner',
  PlayerCompare: 'player_compare',
  ScheduleFilterApplied: 'schedule_filter_applied',
  ScheduleFilterRemoved: 'schedule_filter_removed',
  StandingsFilterApplied: 'standings_filter_applied',
  StatsTabSelected: 'stats_tab_selected',
  UpNextContentViewed: 'up_next_content_viewed',
  VideoEnded: 'video_ended',
  VideoLoaded: 'video_loaded',
  VodFilterApplied: 'vod_filter_applied',
  VodStarted: 'vod_started',
  Watch: 'watch',
  XssoStateChange: 'xsso_state_change'
})

/**
 * The pages supported by analytics.
 */
export const AnalyticsPages = Object.freeze({
  GlobalPartners: 'GlobalPartners',
  Live: 'Live',
  Rewards: 'Rewards',
  Settings: 'Settings',
  Team: 'Team',
  TournamentStandings: 'TournamentStandings',
  Vod: 'Vod',
  Vods: 'Vods'
})

/**
 * A mapping of the supported pages and their respective category.
 */
export const AnalyticsPageCategories = Object.freeze({
  [AnalyticsPages.GlobalPartners]: 'Partners',
  [AnalyticsPages.Live]: 'Watch',
  [AnalyticsPages.Rewards]: 'Rewards',
  [AnalyticsPages.Settings]: 'Settings',
  [AnalyticsPages.Team]: 'Team',
  [AnalyticsPages.TournamentStandings]: 'Events',
  [AnalyticsPages.Vod]: 'Watch',
  [AnalyticsPages.Vods]: 'Watch'
})
